export default "__VITE_ASSET__BsDUzEbw__"